"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "massalengo": {
    "3640705a": [{
      "hkey": "8410f56f",
      "slug": "tripoli-cascina-lanfroia-cascina-priora",
      "name": "Tripoli-Cascina Lanfroia-Cascina Priora",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-lanfroia": [{
      "hkey": "8410f56f",
      "slug": "tripoli-cascina-lanfroia-cascina-priora",
      "name": "Tripoli-Cascina Lanfroia-Cascina Priora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "massalengo"
    }],
    "734f5ff3": [{
      "hkey": "8410f56f",
      "slug": "tripoli-cascina-lanfroia-cascina-priora",
      "name": "Tripoli-Cascina Lanfroia-Cascina Priora",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-priora": [{
      "hkey": "8410f56f",
      "slug": "tripoli-cascina-lanfroia-cascina-priora",
      "name": "Tripoli-Cascina Lanfroia-Cascina Priora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "massalengo"
    }],
    "71420dad": [{
      "hkey": "8410f56f",
      "slug": "tripoli-cascina-lanfroia-cascina-priora",
      "name": "Tripoli-Cascina Lanfroia-Cascina Priora",
      "primary": true,
      "skipSearch": false
    }],
    "localita-tripoli": [{
      "hkey": "8410f56f",
      "slug": "tripoli-cascina-lanfroia-cascina-priora",
      "name": "Tripoli-Cascina Lanfroia-Cascina Priora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "58b56b9f": [{
      "hkey": "92c55ac3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "massalengo-motta-vigana": [{
      "hkey": "92c55ac3",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;